import api from "../../../../../../api/axios";

export default async function getUser(email) {
    const url = `user/v2?email=${encodeURIComponent(email)}`
	const response = await api.get(url,{ timeout: 120000 });
    if (response?.data?.data.length) return response?.data?.data?.[0]
}
